import { Select } from '@lib/components'
import type React from 'react'

import type { PageNameSource } from '@/types'
import css from './PageNamesOption.module.scss'

type Props = {
  value: PageNameSource
  onChange: (value: PageNameSource) => void
}

const SOURCES: { label: string; value: PageNameSource }[] = [
  { label: 'URL', value: 'url' },
  { label: 'Title', value: 'title' },
  { label: 'H1', value: 'h1' },
]

// What an imported page is named after (OCT-5509). A page that has no title or
// h1 keeps its URL name, so the choice can only replace a name, never blank it.
export const PageNamesOption: React.FC<Props> = ({ value, onChange }) => (
  <div className={css.row}>
    <span className={css.subtitle}>Page names</span>
    <Select
      type="select"
      selected={value}
      options={SOURCES}
      onChange={(next) => onChange(next as PageNameSource)}
      disableScrollIntoView
      listMinWidth={120}
      position="bottom-end"
    />
  </div>
)
